import Linkify from "linkify-react";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as actions from "../redux/DashboardAction";
import { CommentField } from "./CommentField";

const Avatar = ({ src, username, size = 33 }) => {
  const [imageError, setImageError] = useState(false);
  const fallback = username ? username.charAt(0).toUpperCase() : "?";

  const avatarStyle = {
    width: `${size}px`,
    height: `${size}px`,
    fontSize: `${size / 2}px`,
  };

  return src && !imageError ? (
    <img
      src={src}
      alt={username}
      className="rounded-circle object-fit-cover"
      style={avatarStyle}
      onError={() => setImageError(true)}
    />
  ) : (
    <div
      className="bg-secondary text-white d-flex justify-content-center align-items-center rounded-circle fw-bold text-uppercase"
      style={avatarStyle}
    >
      {fallback}
    </div>
  );
};

export const InboxDetail = ({ id, isHideComment = false }) => {
  const navigate = useNavigate();
  const { inboxId } = useParams();
  const dispatch = useDispatch();
  const [imagePreview, setImagePreview] = useState();
  const [isImageComment, setIsImageComment] = useState(false);
  const intl = useIntl();
  const dashboardState = useSelector(
    ({ dashboard }) => dashboard,
    shallowEqual
  );

  useEffect(() => {
    if (id || inboxId) {
      dispatch(
        actions.getInboxDetail({
          action: "memberinboxdetail",
          inboxid: id ?? inboxId,
        })
      );

      const outletWrapper = document.querySelector(".outlet-wrapper");
      if (outletWrapper && !isHideComment) {
        outletWrapper.classList.remove("overflow-auto");
        return () => outletWrapper.classList.add("overflow-auto");
      }
    }
  }, [inboxId]);

  useEffect(() => {
    const myEvent = new CustomEvent("manageNavBar", {
      detail: {
        value: false,
      },
    });

    window.dispatchEvent(myEvent);

    return () => {
      dispatch(actions.clearInboxDetail());
      const myEvent = new CustomEvent("manageNavBar", {
        detail: {
          value: true,
        },
      });

      window.dispatchEvent(myEvent);
    };
  }, []);

  return (
    <div>
      {imagePreview && (
        <div
          className="position-absolute top-0 end-0 start-0 bottom-0 d-flex justify-content-center align-items-center"
          style={{ zIndex: "99", background: "rgba(0,0,0,0.5)" }}
          onClick={() => setImagePreview(undefined)}
        >
          <i
            className="position-absolute bi bi-x-circle fs-4"
            style={{ zIndex: "999", top: "5px", right: "5px" }}
          />
          <img
            alt=""
            src={imagePreview}
            style={{ maxHeight: "100%", maxWidth: "100%" }}
          />
        </div>
      )}
      {dashboardState.inboxDetail ? (
        <div
          className="card bg-dark"
          style={!isHideComment ? {
            height: "100vh",
            overflowY: "auto",
          } : {}}
          onScroll={(e) => {
            if (!isHideComment) {
              const target = e.target;
              const isAtBottom =
                target.scrollHeight - target.scrollTop <= target.clientHeight + 5;
              if (
                isAtBottom &&
                (dashboardState.inboxDetail.currentpage ?? "1") !==
                (dashboardState.inboxDetail.totalpage ?? "1") &&
                parseInt(dashboardState.inboxDetail.totalpage ?? "1") > 1 &&
                !dashboardState.listLoading
              ) {
                dispatch(
                  actions.getInboxComment({
                    action: "inboxcommentloadmore",
                    inboxid: inboxId,
                    pageview:
                      parseInt(dashboardState.inboxDetail.currentpage) + 1,
                  })
                );
              }
            }
          }}
        >
          <div className="card-body px-2 pb-2 pt-4 text-white">
            <div className="d-flex ps-2 mb-2">
              {!isHideComment && (
                <i
                  className="bi bi-arrow-left text-white me-2"
                  onClick={() => navigate("/dashboard")}
                />
              )}
              <div className="fw-semibold ">
                {dashboardState.inboxDetail.title}
              </div>
            </div>
            {dashboardState.inboxDetail.content !== "" && (
              <div style={{ fontSize: "14px", whiteSpace: "pre-line" }}>
                <Linkify options={{ target: "_blank", rel: "noopener noreferrer", className: "text-white text-decoration-underline" }}>
                  {dashboardState.inboxDetail.content}
                </Linkify>
              </div>
            )}
            {dashboardState.inboxDetail.imageurl !== "" && (
              <div className="mb-1">
                <img
                  alt=""
                  src={dashboardState.inboxDetail.imageurl}
                  className="w-100"
                />
              </div>
            )}
            {!isHideComment && (
              <>
                <div
                  className="text-end mb-2"
                  style={{ fontSize: "11px", color: "gray" }}
                >
                  {dashboardState.inboxDetail.totalcomment}{" "}
                  {intl.formatMessage({ id: "comment" })}
                </div>
                <div className="d-flex flex-column gap-2">
                  {dashboardState.inboxDetail.memberInboxDetails.map(
                    (memberInboxDetail) => (
                      <div key={memberInboxDetail.itemid} className="d-flex gap-2">
                        <Avatar
                          username={memberInboxDetail.profilename}
                          src={memberInboxDetail.profileimg}
                        />
                        <div>
                          <div
                            className="rounded px-2 py-1"
                            style={{ background: "#373a3e" }}
                          >
                            <div style={{ color: "gray", fontSize: "11px" }}>
                              {memberInboxDetail.profilename}
                            </div>
                            {memberInboxDetail.inboxAttch.length > 0 && (
                              <div className="d-flex align-items-center justify-content-between my-2">
                                {memberInboxDetail.inboxAttch.map(
                                  (inboxAttch, index) => (
                                    <div
                                      key={index}
                                      style={{ width: "50px", height: "50px" }}
                                      className="d-flex align-items-center justify-content-center"
                                      onClick={() =>
                                        setImagePreview(inboxAttch.attchurl)
                                      }
                                    >
                                      <img
                                        src={inboxAttch.attchurl}
                                        alt=""
                                        style={{
                                          maxHeight: "100%",
                                          maxWidth: "100%",
                                        }}
                                      />
                                    </div>
                                  )
                                )}
                              </div>
                            )}

                            <div style={{ fontSize: "14px" }}>
                              <Linkify options={{ target: "_blank", rel: "noopener noreferrer", className: "text-white text-decoration-underline" }}>
                                {memberInboxDetail.content}
                              </Linkify>
                            </div>
                          </div>
                          <div style={{ color: "gray", fontSize: "10px" }}>
                            {memberInboxDetail.lastdate}
                          </div>
                        </div>
                      </div>
                    )
                  )}
                  {dashboardState.listLoading && (
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ height: "40px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden"></span>
                      </div>
                    </div>
                  )}
                  <div style={{ height: "120px" }} />
                </div>
              </>
            )}
          </div>
        </div>
      ) : (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "40px" }}
        >
          <div className="spinner-border" role="status">
            <span className="visually-hidden"></span>
          </div>
        </div>
      )}
      {!isHideComment && (
        <CommentField inboxId={inboxId} setIsImageComment={setIsImageComment} />
      )}
    </div>
  );
};
